import React from 'react';
import { Navigate } from 'react-router-dom';
import { useMultiAgentGate } from '../hooks/useMultiAgentGate';

function InboundRouterGate({ children }) {
  const { loading, isMultiAgent } = useMultiAgentGate();

  if (loading) {
    return (
      <div className="surface-card px-4 py-12 text-center">
        <p className="text-content-muted text-sm">Carregando...</p>
      </div>
    );
  }

  if (!isMultiAgent) {
    return <Navigate to="/agents" replace />;
  }

  return children;
}

export default InboundRouterGate;
